var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { BotNode } from './BotNode';
import { MediaAsset } from 'packages/media/MediaAsset';
var tailwind = require('../../../tailwind.config');
var Bot = /** @class */ (function (_super) {
    __extends(Bot, _super);
    function Bot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.companyId = null;
        _this.avatar = null;
        _this.jobId = null;
        _this.lang = 'en-GB';
        _this.color = null;
        _this.createdAt = null;
        _this.updatedAt = null;
        _this.start = null;
        _this.nodes = null;
        _this.status = null;
        _this.numberOfConversations = null;
        _this.numberOfCandidates = null;
        // This is front-end only attribute for managing embedded bots
        _this.jobLists = [];
        return _this;
    }
    Object.defineProperty(Bot.prototype, "active", {
        get: function () {
            return this.status === 'active';
        },
        enumerable: false,
        configurable: true
    });
    Bot.prototype.avatarSrc = function () {
        return '/common/assets/img/jobibot.png';
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Bot.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        this.color = this.color ? this.color : tailwind.theme.colors.fuchsia;
        this.nodes = Object.values(jsonData.nodes)
            .reduce(function (nodes, value) {
            nodes[value.id] = EntityBuilder.buildOne(BotNode, value);
            return nodes;
        }, {});
        return this;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Bot.prototype.toJson = function (toSnake, asString) {
        if (toSnake === void 0) { toSnake = true; }
        if (asString === void 0) { asString = false; }
        var results = _super.prototype.toJson.call(this, toSnake, false);
        results.nodes = Object.values(this.nodes)
            .reduce(function (nodes, value) {
            nodes[value.id] = value.toJson();
            return nodes;
        }, {});
        return asString ? JSON.stringify(results) : results;
    };
    var _a;
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_a = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _a : Object)
    ], Bot.prototype, "avatar", void 0);
    __decorate([
        Type(Object),
        __metadata("design:type", Object)
    ], Bot.prototype, "nodes", void 0);
    return Bot;
}(Entity));
export { Bot };
